module.exports = __webpack_public_path__ + "faq/img/familt-account.23763ec9.png";